import { T, useTheme, dens, Ico, Card, Eyebrow, Btn, Field } from '../../../design';
import { normalizePhone, fmtPhone } from '../../../utils';
import { BENEFITS } from '../primeConfig';
import { PhoneInput } from './PhoneInput';

export interface MembersSearchProps {
  query: string;
  setQuery: (v: string) => void;
  onSearch: () => void;
  notFound: boolean;
  searching: boolean;
  onInviteNew: (phone: string) => void;
}

function Spin() {
  return <span aria-hidden style={{ width: 16, height: 16, border: `2px solid ${T.border}`, borderTopColor: T.accent, borderRadius: 999, display: 'inline-block', animation: 'pp-spin 0.7s linear infinite' }} />;
}

export function MembersSearch({ query, setQuery, onSearch, notFound, searching, onInviteNew }: MembersSearchProps) {
  const t = useTheme();
  const d = dens(t);
  const valid = normalizePhone(query).length === 8;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: d.gap }}>
      <div style={{ paddingTop: 2 }}>
        <div style={{ fontSize: 23, fontWeight: 800, color: T.fg, letterSpacing: '-0.02em', lineHeight: 1.15 }}>Find PRIME-medlem</div>
        <div style={{ fontSize: 13.5, color: T.fg2, fontWeight: 600, marginTop: 7, lineHeight: 1.5 }}>Indtast kundens mobilnummer for at se medlemskab, fordele og familiemedlemmer.</div>
      </div>

      <Card pad={d.pad}>
        <Field label="Kundens mobilnummer" required>
          <PhoneInput value={query} onChange={setQuery} ariaLabel="Kundens mobilnummer" onEnter={() => valid && onSearch()} autoFocus />
        </Field>
        <Btn full size="lg" style={{ marginTop: 14 }} disabled={!valid || searching} onClick={onSearch} icon={searching ? <Spin /> : <Ico.search size={19} />}>{searching ? 'Søger…' : 'Find medlem'}</Btn>
      </Card>

      {notFound && (
        <Card pad={d.pad} style={{ borderColor: T.errorBorder }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <span style={{ width: 38, height: 38, borderRadius: 11, background: T.errorBg, color: T.error, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Ico.info size={19} /></span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 800, color: T.fg }}>Ingen kunde fundet</div>
              <div style={{ fontSize: 12.5, color: T.fg3, fontWeight: 600, marginTop: 3, lineHeight: 1.5 }}>Der findes ikke et PRIME-medlem på {fmtPhone(query)}. Du kan invitere kunden som nyt medlem.</div>
            </div>
          </div>
          <Btn full size="md" variant="soft" style={{ marginTop: 13 }} icon={<Ico.plus size={18} />} onClick={() => onInviteNew(query)}>Inviter som nyt medlem</Btn>
        </Card>
      )}

      <div>
        <Eyebrow style={{ marginBottom: 10, padding: '4px 2px 0' }}>Fordele som PRIME-kunde</Eyebrow>
        <Card pad={d.pad}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 11 }}>
            {BENEFITS.map((b, i) => (
              <div key={i} style={{ display: 'flex', gap: 11, alignItems: 'flex-start' }}>
                <span style={{ width: 20, height: 20, borderRadius: 999, background: T.accentLight, color: t.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}><Ico.check size={13} strokeWidth={2.6} /></span>
                <span style={{ fontSize: 13, color: T.fg, fontWeight: 600, lineHeight: 1.4 }}>{b}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
